import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setLoading } from '../../redux/Slices/boardSlice';
import { closeExpandableColumn } from '../../redux/Slices/expandableColumnSlice';
import { openModal } from '../../redux/Slices/modalSlice';
import Add from '../icons/Add';
import './SidebarBoardList.scss';

const SidebarBoardList = ({ isExpanded, currentBoard, workspaceBoards, workspaceId }) => {
    const dispatch = useDispatch();
    const { workspaces } = useSelector((state) => state.workspaces);
    const scrollRef = useRef(null);
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);

    const checkScroll = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;
        setCanScrollUp(el.scrollTop > 0);
        setCanScrollDown(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
    }, []);

    useEffect(() => {
        checkScroll();
    }, [workspaceBoards, checkScroll]);

    const handleBoardClick = () => {
        dispatch(setLoading(true));
        dispatch(closeExpandableColumn());
    };

    const handleCreateBoard = () => {
        const workspaceIndex = workspaces.findIndex(ws => ws.shortId === workspaceId);
        dispatch(openModal({ modalType: 'CREATE_BOARD', modalData: { defaultSelectedOption: workspaceIndex >= 0 ? workspaceIndex : 0 } }));
    };

    return (
        <div className="sidebar-board-list">
            {/* Board List */}
            <div className={`board-list-wrapper${canScrollUp ? ' has-overflow-top' : ''}${canScrollDown ? ' has-overflow-bottom' : ''}`}>
            <div className="board-list-scroll" ref={scrollRef} onScroll={checkScroll}>
                {workspaceBoards && workspaceBoards.length > 0 ? (
                    workspaceBoards.map(board => (
                        <div
                            className={`board-item${currentBoard?.shortId === board.shortId ? ' active' : ''}`}
                            key={board._id}
                            data-tooltip-content={!isExpanded ? board.title : ''}
                            data-tooltip-position="right"
                        >
                            <div className="board-thumbnail">
                                {board.cover?.sizes?.thumbnail || board.cover?.url ? (
                                    <img
                                        src={board.cover?.sizes?.thumbnail || board.cover?.url}
                                        alt={board.title}
                                        loading="lazy"
                                    />
                                ) : (
                                    <div
                                        className="board-thumbnail-placeholder"
                                        style={{
                                            background: board.cover?.coverColor?.[2] || 'var(--input-background-color)'
                                        }}
                                    >
                                        {board.title?.charAt(0)?.toUpperCase()}
                                    </div>
                                )}
                            </div>
                            {isExpanded && (
                                <span className="board-title">{board.title}</span>
                            )}

                            {currentBoard?.shortId !== board.shortId && (
                                <Link
                                    to={board.permalink}
                                    className="board-nav-link"
                                    onClick={handleBoardClick}
                                />
                            )}
                        </div>
                    ))
                ) : (
                    /* Loading skeletons */
                    Array.from({ length: 4 }).map((_, i) => (
                        <div className="board-skeleton" key={i}>
                            <div className="skeleton-thumb" />
                            {isExpanded && <div className="skeleton-text" />}
                        </div>
                    ))
                )}
            </div>
            </div>

            {/* Create Board Button */}
            <div
                className="create-board-btn"
                onClick={handleCreateBoard}
                data-tooltip-content={!isExpanded ? 'Create board' : ''}
                data-tooltip-position="right"
            >
                <Add size={20} color='#fff' />
                {isExpanded && <span>Create board</span>}
            </div>
        </div>
    );
};

export default SidebarBoardList;
